// Central API client — every request goes through `apiFetch`.
// Keeps auth-token plumbing and error normalization in one place.

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

function getAuthToken() {
  return localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
}

function buildQuery(params) {
  if (!params) return '';
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.append(k, v);
  });
  const s = qs.toString();
  return s ? `?${s}` : '';
}

export async function apiFetch(path, { method = 'GET', body, params, headers = {}, raw = false } = {}) {
  const token = getAuthToken();
  const url = `${API_BASE_URL}${path}${buildQuery(params)}`;
  const opts = {
    method,
    headers: {
      ...(body && !(body instanceof FormData) ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
  };
  if (body !== undefined) {
    opts.body = body instanceof FormData ? body : JSON.stringify(body);
  }
  const res = await fetch(url, opts);
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    let payload = null;
    try {
      payload = await res.json();
      // FastAPI normally sets `detail`; may be a string OR a structured object.
      if (payload && typeof payload.detail === 'string') {
        detail = payload.detail;
      } else if (payload && payload.detail && typeof payload.detail === 'object' && payload.detail.error) {
        detail = payload.detail.error;
      }
    } catch (_) {}
    const error = new Error(detail);
    error.status = res.status;
    error.data = payload;  // preserve structured body for callers that need it
    throw error;
  }
  if (raw) return res;
  const ct = res.headers.get('content-type') || '';
  return ct.includes('application/json') ? res.json() : res.text();
}

export { API_BASE_URL };
